import { cn } from "@sunfish/lib/utils";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "rounded-md bg-gradient-to-r from-muted via-card to-muted dark:via-white/10 bg-[length:200%_100%] motion-safe:animate-shimmer motion-reduce:bg-primary/10 motion-reduce:bg-none",
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
